/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigListRequest {
    getFixupPrototypeFunction() { return LockConfigListRequest.fixupPrototype; }

    static newInstance(model: Partial<LockConfigListRequest>): LockConfigListRequest {
        let obj = Object.assign(new LockConfigListRequest(), model);
        LockConfigListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigListRequest>): LockConfigListRequest {
        if (!model) return null;
        return LockConfigListRequest.newInstance(<LockConfigListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigListRequest) {
        if (!obj) return;

        models.LockConfigListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigListRequest): boolean {
        Object.setPrototypeOf(obj, LockConfigListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.LockConfigFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.LockConfigDetailsSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.LockConfigDetailsSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.LockConfigFilter;

}
